
import SettingsApi from '@/api/settingsApi'
const settingsApi = new SettingsApi()


export default {
  async getNewId () {
    return await settingsApi.getNewId()
  },
}